export default [
    {
        text: 'Стартовый',
        icon: 'remove_red_eye',
        value: 'start',
        action_text: 'Сделать стартовым'
    },
    {
        text: 'Видимый',
        icon: 'remove_red_eye',
        value: 'visible',
        action_text: 'Сделать видимым'
    },
    {
        text: 'Пробный',
        icon: 'remove_red_eye',
        value: 'trial',
        action_text: 'Сделать пробным'
    },
    {
        text: 'Скрытый',
        icon: 'lock',
        value: 'close',
        action_text: 'Скрыть'
    },
    {
        text: 'Черновик',
        icon: 'edit',
        value: 'draft',
        action_text: 'Черновик'
    },
    {
        text: 'Удаленный',
        icon: 'delete',
        value: 'deleted',
        action_text: 'Удалить'
    }
];
